module.exports = __webpack_public_path__ + "static/media/bren.930b71e6.jpg";